import React from "react";
import {
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
} from "@mui/material";
import { TableLoader, TableNotFound } from "src/Utils/TableLoader";
import type { IScanHistoryItem } from "../type/ticketScanType";
import ScanHistoryTableRow from "./ScanHistoryTableRow";

interface Props {
	isLoading: boolean;
	data: IScanHistoryItem[];
	paginationSkip: number | string;
}

const ScanHistoryTable: React.FC<Props> = ({
	isLoading,
	data,
	paginationSkip,
}) => {
	return (
		<TableContainer>
			<Table>
				<TableHead>
					<TableRow sx={{ bgcolor: "#f8fafc" }}>
						<TableCell sx={{ fontWeight: "bold" }}>SL.</TableCell>
						<TableCell sx={{ fontWeight: "bold" }}>Scan Time</TableCell>
						<TableCell sx={{ fontWeight: "bold" }}>Ticket No</TableCell>
						<TableCell sx={{ fontWeight: "bold" }}>Scan Type</TableCell>
						<TableCell sx={{ fontWeight: "bold" }}>Visitor Info</TableCell>
						<TableCell sx={{ fontWeight: "bold" }}>Organization</TableCell>
						<TableCell sx={{ fontWeight: "bold" }}>Total Amount</TableCell>
						<TableCell sx={{ fontWeight: "bold" }}>Payment Status</TableCell>
						<TableCell sx={{ fontWeight: "bold" }}>Scanned By</TableCell>
					</TableRow>
				</TableHead>

				{isLoading ? (
					<TableLoader />
				) : data && data.length > 0 ? (
					<TableBody>
						{data.map((scan, index) => (
							<ScanHistoryTableRow
								key={scan.id || index}
								scan={scan}
								index={index}
								paginationSkip={paginationSkip}
							/>
						))}
					</TableBody>
				) : (
					<TableNotFound />
				)}
			</Table>
		</TableContainer>
	);
};

export default ScanHistoryTable;
